import * as i0 from '@angular/core';
import { Pipe, InjectionToken, Injectable, Inject, Component, PLATFORM_ID, ViewChild, Directive, Input, EventEmitter, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i3 from '@angular/material/input';
import { MatInputModule } from '@angular/material/input';
import * as i4 from '@angular/material/form-field';
import { MatFormFieldModule } from '@angular/material/form-field';
import * as i5 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i5$1 from '@angular/material/checkbox';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { Subject } from 'rxjs';
import { takeUntil, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import * as i4$1 from '@angular/material/radio';
import { MatRadioModule } from '@angular/material/radio';
import * as i4$2 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i5$2 from '@angular/material/core';
import * as i4$3 from '@angular/material/slide-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import * as i4$4 from 'ngx-quill';
import { QuillModule } from 'ngx-quill';
function FormInputComponent_mat_form_field_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 11);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r0.config.subLabel, i0.ɵɵsanitizeHtml);
  }
}
function FormInputComponent_mat_form_field_1_input_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "input", 12);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formControlName", ctx_r0.config.name)("placeholder", ctx_r0.config.placeholder || "")("autocomplete", ctx_r0.config.autocomplete)("type", ctx_r0.config.inputType || "text");
  }
}
function FormInputComponent_mat_form_field_1_textarea_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "textarea", 13);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formControlName", ctx_r0.config.name)("rows", ctx_r0.config["rows"] ? ctx_r0.config["rows"] : "5")("autocomplete", ctx_r0.config.autocomplete)("placeholder", ctx_r0.config.placeholder || "");
  }
}
function FormInputComponent_mat_form_field_1_mat_icon_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.config.matPrefix);
  }
}
function FormInputComponent_mat_form_field_1_mat_icon_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.config.matSuffix);
  }
}
function FormInputComponent_mat_form_field_1_mat_hint_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-hint", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.config.hint);
  }
}
function FormInputComponent_mat_form_field_1_mat_error_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-error", 3);
    i0.ɵɵpipe(1, "formError");
  }
  if (rf & 2) {
    const field_r2 = i0.ɵɵnextContext().ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, field_r2, ctx_r0.config.customValidationMessages), i0.ɵɵsanitizeHtml);
  }
}
function FormInputComponent_mat_form_field_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-form-field", 2);
    i0.ɵɵelement(1, "mat-label", 3);
    i0.ɵɵtemplate(2, FormInputComponent_mat_form_field_1_div_2_Template, 1, 1, "div", 4)(3, FormInputComponent_mat_form_field_1_input_3_Template, 1, 4, "input", 5)(4, FormInputComponent_mat_form_field_1_textarea_4_Template, 1, 4, "textarea", 6)(5, FormInputComponent_mat_form_field_1_mat_icon_5_Template, 2, 1, "mat-icon", 7)(6, FormInputComponent_mat_form_field_1_mat_icon_6_Template, 2, 1, "mat-icon", 8)(7, FormInputComponent_mat_form_field_1_mat_hint_7_Template, 2, 1, "mat-hint", 9)(8, FormInputComponent_mat_form_field_1_mat_error_8_Template, 2, 4, "mat-error", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const field_r2 = ctx.ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("has--label", !!ctx_r0.config.label)("has--sub-label", !!ctx_r0.config.subLabel);
    i0.ɵɵproperty("appearance", ctx_r0.config.appearance || "fill")("color", ctx_r0.config.color || "accent")("ngClass", ctx_r0.iconClass)("subscriptSizing", ctx_r0.config.subscriptSizing || "fixed");
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.config.label, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.subLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r0.config == null ? null : ctx_r0.config.fieldType) !== "textarea");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r0.config == null ? null : ctx_r0.config.fieldType) === "textarea");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.matPrefix);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.matSuffix);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.hint);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", field_r2.invalid);
  }
}
function FormButtonToggleComponent_mat_form_field_1_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormButtonToggleComponent_mat_form_field_1_mat_error_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-error", 5);
    i0.ɵɵpipe(1, "formError");
  }
  if (rf & 2) {
    const field_r1 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, field_r1, ctx_r1.config.customValidationMessages), i0.ɵɵsanitizeHtml);
  }
}
function FormButtonToggleComponent_mat_form_field_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-form-field", 2)(1, "mat-label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 3);
    i0.ɵɵelementStart(4, "mat-checkbox", 4);
    i0.ɵɵelement(5, "span", 5);
    i0.ɵɵtemplate(6, FormButtonToggleComponent_mat_form_field_1_span_6_Template, 2, 0, "span", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, FormButtonToggleComponent_mat_form_field_1_mat_error_7_Template, 2, 4, "mat-error", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const field_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("has--label", !!ctx_r1.config.label)("has--sub-label", !!ctx_r1.config.subLabel);
    i0.ɵɵproperty("appearance", ctx_r1.config.appearance || "fill")("subscriptSizing", ctx_r1.config.subscriptSizing || "fixed");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.config.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", ctx_r1.config.name)("hidden", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", ctx_r1.config.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r1.config["checkboxLabel"], i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isRequired(field_r1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", field_r1.invalid);
  }
}
const _c0 = a0 => ({
  "custom-field--invalid": a0
});
function FormCheckboxListComponent_div_1_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormCheckboxListComponent_div_1_li_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 11)(1, "mat-checkbox", 12);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const option_r1 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", option_r1.title)("formControlName", ctx_r1.config.name + "_option_" + option_r1.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r1.title, " ");
  }
}
function FormCheckboxListComponent_div_1_mat_error_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-error", 13);
    i0.ɵɵpipe(1, "formError");
  }
  if (rf & 2) {
    const field_r3 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, field_r3, ctx_r1.config.customValidationMessages), i0.ɵɵsanitizeHtml);
  }
}
function FormCheckboxListComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "input", 3);
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵtemplate(4, FormCheckboxListComponent_div_1_span_4_Template, 2, 0, "span", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "ul", 6);
    i0.ɵɵtemplate(6, FormCheckboxListComponent_div_1_li_6_Template, 3, 3, "li", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 8);
    i0.ɵɵtemplate(8, FormCheckboxListComponent_div_1_mat_error_8_Template, 2, 4, "mat-error", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const field_r3 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("has--label", !!ctx_r1.config.label)("has--sub-label", !!ctx_r1.config.subLabel);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c0, ctx_r1.showError(field_r3)));
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", ctx_r1.config.name)("hidden", true);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.config.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isRequired(ctx_r1.group.get(ctx_r1.config.name)));
    i0.ɵɵadvance();
    i0.ɵɵproperty("formGroup", ctx_r1.checkBoxes);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.config.selectOptions);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.showError(field_r3));
  }
}
function FormCheckboxComponent_mat_form_field_1_span_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormCheckboxComponent_mat_form_field_1_mat_error_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-error", 5);
    i0.ɵɵpipe(1, "formError");
  }
  if (rf & 2) {
    const field_r1 = i0.ɵɵnextContext().ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, field_r1, ctx_r1.config.customValidationMessages), i0.ɵɵsanitizeHtml);
  }
}
function FormCheckboxComponent_mat_form_field_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-form-field", 2)(1, "mat-label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 3);
    i0.ɵɵelementStart(4, "mat-checkbox", 4);
    i0.ɵɵelement(5, "span", 5);
    i0.ɵɵtemplate(6, FormCheckboxComponent_mat_form_field_1_span_6_Template, 2, 0, "span", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, FormCheckboxComponent_mat_form_field_1_mat_error_7_Template, 2, 4, "mat-error", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const field_r1 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("has--label", !!ctx_r1.config.label)("has--sub-label", !!ctx_r1.config.subLabel);
    i0.ɵɵproperty("subscriptSizing", ctx_r1.config.subscriptSizing || "fixed");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.config.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", ctx_r1.config.name)("hidden", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", ctx_r1.config.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r1.config["checkboxLabel"], i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isRequired(field_r1));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", field_r1.invalid);
  }
}
function FormHiddenComponent_input_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "input", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formControlName", ctx_r0.config.name);
  }
}
function FormRadioComponent_div_1_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 9);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function FormRadioComponent_div_1_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10)(1, "mat-radio-button", 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const option_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("value", option_r1.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r1.title, " ");
  }
}
function FormRadioComponent_div_1_mat_error_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-error", 12);
    i0.ɵɵpipe(1, "formError");
  }
  if (rf & 2) {
    const field_r2 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, field_r2, ctx_r2.config.customValidationMessages), i0.ɵɵsanitizeHtml);
  }
}
function FormRadioComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "span", 3);
    i0.ɵɵtext(2);
    i0.ɵɵtemplate(3, FormRadioComponent_div_1_span_3_Template, 2, 0, "span", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-radio-group", 5);
    i0.ɵɵtemplate(5, FormRadioComponent_div_1_div_5_Template, 3, 2, "div", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 7);
    i0.ɵɵtemplate(7, FormRadioComponent_div_1_mat_error_7_Template, 2, 4, "mat-error", 8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const field_r2 = ctx.ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("has--label", !!ctx_r2.config.label)("has--sub-label", !!ctx_r2.config.subLabel);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c0, ctx_r2.showError(field_r2)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.config.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isRequired(field_r2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", ctx_r2.config.name);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r2.config.selectOptions);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.showError(field_r2));
  }
}
function FormSelectComponent_mat_form_field_2_mat_option_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const option_r1 = ctx.$implicit;
    i0.ɵɵproperty("value", option_r1.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", option_r1.title, " ");
  }
}
function FormSelectComponent_mat_form_field_2_mat_error_5_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "a", 8);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const help_r2 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", help_r2.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", help_r2.title, " ");
  }
}
function FormSelectComponent_mat_form_field_2_mat_error_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-error");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "formError");
    i0.ɵɵtemplate(3, FormSelectComponent_mat_form_field_2_mat_error_5_ng_container_3_Template, 3, 2, "ng-container", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const field_r3 = i0.ɵɵnextContext().ngIf;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 2, field_r3, ctx_r3.config.customValidationMessages), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.config.helpLink);
  }
}
function FormSelectComponent_mat_form_field_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-form-field", 3)(1, "mat-label");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-select", 4);
    i0.ɵɵtemplate(4, FormSelectComponent_mat_form_field_2_mat_option_4_Template, 2, 2, "mat-option", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, FormSelectComponent_mat_form_field_2_mat_error_5_Template, 4, 5, "mat-error", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const field_r3 = ctx.ngIf;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("has--label", !!ctx_r3.config.label)("has--sub-label", !!ctx_r3.config.subLabel);
    i0.ɵɵproperty("appearance", ctx_r3.config.appearance || "fill")("color", ctx_r3.config.color || "accent")("subscriptSizing", ctx_r3.config.subscriptSizing || "fixed");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.config.label, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", ctx_r3.config.name)("placeholder", ctx_r3.config.placeholder || "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r3.config.selectOptions);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", field_r3.invalid);
  }
}
function FormSelectComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "a", 10);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const help_r5 = ctx.ngIf;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", "mat-" + ctx_r3.config.color || "mat-primary");
    i0.ɵɵadvance();
    i0.ɵɵproperty("href", help_r5.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", help_r5.title, " ");
  }
}
function FormSlideToggleComponent_div_2_mat_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-label", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.config.label);
  }
}
function FormSlideToggleComponent_div_2_p_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.config["intro"]);
  }
}
function FormSlideToggleComponent_div_2_mat_error_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-error", 9);
    i0.ɵɵpipe(1, "formError");
  }
  if (rf & 2) {
    const field_r2 = i0.ɵɵnextContext().ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, field_r2, ctx_r0.config.customValidationMessages), i0.ɵɵsanitizeHtml);
  }
}
function FormSlideToggleComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, FormSlideToggleComponent_div_2_mat_label_1_Template, 2, 1, "mat-label", 4)(2, FormSlideToggleComponent_div_2_p_2_Template, 2, 1, "p", 5);
    i0.ɵɵelementStart(3, "mat-slide-toggle", 6);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, FormSlideToggleComponent_div_2_mat_error_5_Template, 2, 4, "mat-error", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const field_r2 = ctx.ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("has--label", !!ctx_r0.config.label)("has--sub-label", !!ctx_r0.config.subLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config["intro"]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("color", ctx_r0.config.color)("formControlName", ctx_r0.config.name);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.config["slideToggleLabel"], " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", field_r2.invalid);
  }
}
const _c1 = ["editor"];
function WysiwygEditorComponent_ng_container_0_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function WysiwygEditorComponent_ng_container_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", ctx_r0.config.subLabel, i0.ɵɵsanitizeHtml);
  }
}
function WysiwygEditorComponent_ng_container_0_quill_editor_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "quill-editor", 11, 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("modules", ctx_r0.modules)("placeholder", ctx_r0.config.placeholder || "")("formControlName", ctx_r0.config.name)("minLength", ctx_r0.config["minLength"] || 0)("maxLength", ctx_r0.config.maxLength);
  }
}
function WysiwygEditorComponent_ng_container_0_quill_editor_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "quill-editor", 12, 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("modules", ctx_r0.modules)("placeholder", ctx_r0.config.placeholder || "")("formControlName", ctx_r0.config.name)("minLength", ctx_r0.config["minLength"] || 0);
  }
}
function WysiwygEditorComponent_ng_container_0_mat_error_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-error", 4);
    i0.ɵɵpipe(1, "formError");
  }
  if (rf & 2) {
    const field_r2 = i0.ɵɵnextContext().ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, field_r2, ctx_r0.config.customValidationMessages), i0.ɵɵsanitizeHtml);
  }
}
function WysiwygEditorComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2)(2, "label", 3);
    i0.ɵɵelement(3, "span", 4);
    i0.ɵɵtemplate(4, WysiwygEditorComponent_ng_container_0_span_4_Template, 2, 0, "span", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, WysiwygEditorComponent_ng_container_0_div_5_Template, 1, 1, "div", 5)(6, WysiwygEditorComponent_ng_container_0_quill_editor_6_Template, 2, 5, "quill-editor", 6)(7, WysiwygEditorComponent_ng_container_0_quill_editor_7_Template, 2, 4, "quill-editor", 7);
    i0.ɵɵelementStart(8, "div", 8);
    i0.ɵɵtemplate(9, WysiwygEditorComponent_ng_container_0_mat_error_9_Template, 2, 4, "mat-error", 9);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const field_r2 = ctx.ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("has--label", !!ctx_r0.config.label)("has--sub-label", !!ctx_r0.config.subLabel);
    i0.ɵɵproperty("formGroup", ctx_r0.group)("ngClass", i0.ɵɵpureFunction1(12, _c0, ctx_r0.showError(field_r2)));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r0.config.label, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.isRequired(field_r2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.subLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.config.maxLength);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.config.maxLength);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.showError(field_r2));
  }
}
const _c2 = [[["", "slot", "form-alert"]], [["", "slot", "form-actions"]]];
const _c3 = ["[slot=form-alert]", "[slot=form-actions]"];
function FormComponent_ng_container_2_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelementContainer(1, 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const field_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", field_r2.cssClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("config", field_r2)("group", ctx_r2.form);
  }
}
function FormComponent_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormComponent_ng_container_2_div_1_Template, 2, 3, "div", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const field_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", field_r2.control !== "none" && ctx_r2.shouldBeDisplayed(field_r2) && field_r2.inputType !== "hidden");
  }
}
function FormComponent_fieldset_4_ng_container_9_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelementContainer(1, 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const field_r6 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", field_r6.cssClass);
    i0.ɵɵadvance();
    i0.ɵɵproperty("config", field_r6)("group", ctx_r2.form);
  }
}
function FormComponent_fieldset_4_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormComponent_fieldset_4_ng_container_9_div_1_Template, 2, 3, "div", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const field_r6 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", field_r6.control !== "none" && ctx_r2.shouldBeDisplayed(field_r6) && field_r6.inputType !== "hidden");
  }
}
function FormComponent_fieldset_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fieldset", 11);
    i0.ɵɵpipe(1, "forFieldset");
    i0.ɵɵelementStart(2, "div", 12)(3, "legend", 13);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 14);
    i0.ɵɵlistener("click", function FormComponent_fieldset_4_Template_button_click_5_listener() {
      const f_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      return i0.ɵɵresetView(f_r5.collapsed = !f_r5.collapsed);
    });
    i0.ɵɵelementStart(6, "mat-icon");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(8, "div", 15);
    i0.ɵɵtemplate(9, FormComponent_fieldset_4_ng_container_9_Template, 2, 1, "ng-container", 2);
    i0.ɵɵpipe(10, "forFieldset");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const f_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("is--hidden", !ctx_r2.fieldsetShouldBeDisplayed(i0.ɵɵpipeBind2(1, 7, ctx_r2.config, f_r5.name)));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(f_r5.title || f_r5.name);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(f_r5.collapsed ? "add" : "remove");
    i0.ɵɵadvance();
    i0.ɵɵclassProp("is--collapsed", f_r5.collapsed);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(10, 10, ctx_r2.config, f_r5.name));
  }
}
function FormComponent_ng_container_6_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelement(1, "span", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r2.inputErrorMessage || ctx_r2.defaultFormConfig.genericInputErrorMessage, i0.ɵɵsanitizeHtml);
  }
}
function FormComponent_ng_container_6_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelement(1, "span", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r2.inputErrorMessage || ctx_r2.defaultFormConfig.genericInputErrorMessage, i0.ɵɵsanitizeHtml);
  }
}
function FormComponent_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, FormComponent_ng_container_6_div_1_Template, 2, 1, "div", 16)(2, FormComponent_ng_container_6_div_2_Template, 2, 1, "div", 16);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.triedSubmit && !ctx_r2.form.valid);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.serverError);
  }
}
function FormComponent_button_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 19)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.submitButtonLabel);
  }
}
function FormComponent_pre_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "pre", 20);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "json");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("  ", i0.ɵɵpipeBind1(2, 1, ctx_r2.form.getRawValue()), "\n");
  }
}
let ForFieldsetPipe = /*#__PURE__*/(() => {
  class ForFieldsetPipe {
    transform(value, fieldset) {
      if (!value || !fieldset || !fieldset.length) {
        return value;
      }
      return value.filter(a => a.fieldset === fieldset);
    }
    static {
      this.ɵfac = function ForFieldsetPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ForFieldsetPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "forFieldset",
        type: ForFieldsetPipe,
        pure: true
      });
    }
  }
  return ForFieldsetPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * This is not a real service, but it looks like it from the outside.
 * It's just an InjectionTToken used to import the config object, provided from the outside
 */
const DynamicFormConfigService = new InjectionToken('DynamicFormConfig');
let ValidatorMessagesService = /*#__PURE__*/(() => {
  class ValidatorMessagesService {
    constructor() {
      this.validatorMessages = {
        email: 'Dit is geen correct e-mailadres.',
        tel: 'Dit is geen correct telefoonnummer.',
        pattern: 'Dit is geen correcte waarde.',
        address_not_found: 'Dit adres is niet gevonden. Klopt de bovenstaande postcode en huisnummer? Zo ja vul onderstaande woonplaats en straatnaam in.',
        required: 'Dit veld is verplicht.',
        maxlength: null,
        maxLengthError: null,
        misc: 'Er is een onbekende fout opgetreden.',
        min: 'De waarde is te laag.'
      };
    }
    static {
      this.ɵfac = function ValidatorMessagesService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ValidatorMessagesService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ValidatorMessagesService,
        factory: ValidatorMessagesService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ValidatorMessagesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormErrorPipe = /*#__PURE__*/(() => {
  class FormErrorPipe {
    constructor(srv, defaultFormConfig) {
      this.srv = srv;
      this.defaultFormConfig = defaultFormConfig;
    }
    transform(ctrl, customValidationMessages) {
      const errorKey = Object.keys(ctrl?.errors || {})?.[0] || '';
      // Custom error in control config
      if (customValidationMessages && customValidationMessages[errorKey]) {
        return customValidationMessages[errorKey];
      }
      if (ctrl.hasError('email')) {
        return this.srv.validatorMessages.email;
      }
      if (ctrl.hasError('tel')) {
        return this.srv.validatorMessages.tel;
      }
      if (ctrl.hasError('pattern')) {
        return this.srv.validatorMessages.pattern;
      }
      if (ctrl.hasError('address_not_found')) {
        return this.srv.validatorMessages.address_not_found;
      }
      if (ctrl.hasError('required')) {
        return this.srv.validatorMessages.required;
      }
      if (ctrl.hasError('min')) {
        return this.srv.validatorMessages.min || 'De waarde is te laag.';
      }
      if (ctrl.hasError('maxlength')) {
        return this.srv.validatorMessages.maxlength || `De tekst is te lang. ${ctrl.getError('maxlength').actualLength} karakters van de ${ctrl.getError('maxlength').requiredLength} gebruikt.`;
      }
      if (ctrl.hasError('maxLengthError')) {
        return this.srv.validatorMessages.maxLengthError || `De tekst is te lang. ${ctrl.getError('maxLengthError').given} karakters van de ${ctrl.getError('maxLengthError').maxLength} gebruikt.`;
      }
      // custom error in default config as fallback
      // Check if formControlErrors config has error like first error that comes up in control if past checks didn't match
      if (Object.keys(this.defaultFormConfig.formControlErrors || {}).includes(errorKey)) {
        return this.defaultFormConfig.formControlErrors?.[errorKey] || '';
      }
      // Fallback
      return this.srv.validatorMessages.misc;
    }
    static {
      this.ɵfac = function FormErrorPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormErrorPipe)(i0.ɵɵdirectiveInject(ValidatorMessagesService, 16), i0.ɵɵdirectiveInject(DynamicFormConfigService, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "formError",
        type: FormErrorPipe,
        pure: false
      });
    }
  }
  return FormErrorPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormInputComponent = /*#__PURE__*/(() => {
  class FormInputComponent {
    constructor() {}
    ngOnInit() {}
    get iconClass() {
      const prefixClass = this.config.matPrefix ? 'has--prefix-icon' : '';
      const suffixClass = this.config.matSuffix ? 'has--suffix-icon' : '';
      return `${prefixClass} ${suffixClass}`;
    }
    static {
      this.ɵfac = function FormInputComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormInputComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FormInputComponent,
        selectors: [["app-form-input"]],
        decls: 2,
        vars: 2,
        consts: [[3, "formGroup"], [3, "appearance", "color", "has--label", "has--sub-label", "ngClass", "subscriptSizing", 4, "ngIf"], [3, "appearance", "color", "ngClass", "subscriptSizing"], [3, "innerHTML"], ["class", "mat-form-field-subLabel", 3, "innerHTML", 4, "ngIf"], ["matInput", "", 3, "formControlName", "placeholder", "autocomplete", "type", 4, "ngIf"], ["matInput", "", 3, "formControlName", "rows", "autocomplete", "placeholder", 4, "ngIf"], ["matPrefix", "", 4, "ngIf"], ["matSuffix", "", 4, "ngIf"], ["align", "start", 4, "ngIf"], [3, "innerHTML", 4, "ngIf"], [1, "mat-form-field-subLabel", 3, "innerHTML"], ["matInput", "", 3, "formControlName", "placeholder", "autocomplete", "type"], ["matInput", "", 3, "formControlName", "rows", "autocomplete", "placeholder"], ["matPrefix", ""], ["matSuffix", ""], ["align", "start"]],
        template: function FormInputComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementContainerStart(0, 0);
            i0.ɵɵtemplate(1, FormInputComponent_mat_form_field_1_Template, 9, 16, "mat-form-field", 1);
            i0.ɵɵelementContainerEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.group);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.group.get(ctx.config.name));
          }
        },
        dependencies: [i1.NgClass, i1.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, i2.FormGroupDirective, i2.FormControlName, i3.MatInput, i4.MatFormField, i4.MatLabel, i4.MatHint, i4.MatError, i4.MatPrefix, i4.MatSuffix, i5.MatIcon, FormErrorPipe],
        encapsulation: 2
      });
    }
  }
  return FormInputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormButtonToggleComponent = /*#__PURE__*/(() => {
  class FormButtonToggleComponent {
    constructor() {}
    ngOnInit() {}
    isRequired(ctrl) {
      if (!ctrl.validator) {
        return false;
      }
      const validator = ctrl?.validator({});
      return validator && validator['required'];
    }
    static {
      this.ɵfac = function FormButtonToggleComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormButtonToggleComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FormButtonToggleComponent,
        selectors: [["app-form-button-toggle"]],
        decls: 2,
        vars: 2,
        consts: [[3, "formGroup"], ["class", "mat-form-field--checkbox", 3, "appearance", "has--label", "has--sub-label", "subscriptSizing", 4, "ngIf"], [1, "mat-form-field--checkbox", 3, "appearance", "subscriptSizing"], ["matInput", "", 3, "formControlName", "hidden"], [3, "formControlName"], [3, "innerHTML"], ["class", "mat-form-field-required-marker", 4, "ngIf"], [3, "innerHTML", 4, "ngIf"], [1, "mat-form-field-required-marker"]],
        template: function FormButtonToggleComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementContainerStart(0, 0);
            i0.ɵɵtemplate(1, FormButtonToggleComponent_mat_form_field_1_Template, 8, 13, "mat-form-field", 1);
            i0.ɵɵelementContainerEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.group);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.group.get(ctx.config.name));
          }
        },
        dependencies: [i1.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, i2.FormGroupDirective, i2.FormControlName, i3.MatInput, i4.MatFormField, i4.MatLabel, i4.MatError, i5$1.MatCheckbox, FormErrorPipe]
      });
    }
  }
  return FormButtonToggleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormCheckboxListComponent = /*#__PURE__*/(() => {
  class FormCheckboxListComponent {
    constructor(fb) {
      this.fb = fb;
      this.checkBoxes = this.fb.group({});
      this._unsubscribe = new Subject();
    }
    ngOnInit() {
      this.config['selectOptions']?.forEach(option => {
        const initialValue = this.config.value && this.config.value.some(b => b.id === option.id);
        this.checkBoxes.addControl(`${this.config.name}_option_${option.id}`, this.fb.control(initialValue));
      });
      // Update checkboxgroup value to array of selected checkboxes
      this.checkBoxes.valueChanges.pipe(takeUntil(this._unsubscribe)).subscribe(val => {
        let selectedAsArray = Object.keys(val).filter(k => val[k]) || [];
        selectedAsArray = selectedAsArray.length > 0 ? selectedAsArray : null;
        const objectArray = this.config.selectOptions?.filter(a => {
          const i = (selectedAsArray || []).indexOf(`${this.config.name}_option_${a.id}`);
          return i >= 0;
        }) || [];
        this.group.get(this.config.name)?.patchValue(objectArray);
      });
      // If value changes outside component (patchvalue) set checkboxvalues
      this.group.get(this.config.name)?.valueChanges.subscribe(values => {
        if (!values?.length) {
          return;
        }
        values.forEach(name => {
          const ctrl = this.checkBoxes.controls[`${this.config.name}_option_${name}`];
          if (ctrl) {
            ctrl.setValue(true);
          }
        });
      });
    }
    isRequired(ctrl) {
      if (!ctrl?.validator) {
        return false;
      }
      const validator = ctrl?.validator({});
      return validator && validator['required'];
    }
    showError(field) {
      return field.invalid && (this.checkBoxes.touched || this.checkBoxes.dirty);
    }
    ngOnDestroy() {
      this._unsubscribe.next();
      this._unsubscribe.complete();
    }
    static {
      this.ɵfac = function FormCheckboxListComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormCheckboxListComponent)(i0.ɵɵdirectiveInject(i2.UntypedFormBuilder));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FormCheckboxListComponent,
        selectors: [["app-form-checkbox-list"]],
        decls: 2,
        vars: 2,
        consts: [[3, "formGroup"], ["class", "custom-field", 3, "has--label", "has--sub-label", "ngClass", 4, "ngIf"], [1, "custom-field", 3, "ngClass"], ["matInput", "", 3, "formControlName", "hidden"], [1, "label"], ["class", "mat-form-field-required-marker", 4, "ngIf"], [1, "custom-field__field", 3, "formGroup"], ["class", "mat-form-field mb-1", 4, "ngFor", "ngForOf"], [1, "custom-field__error-wrapper"], [3, "innerHTML", 4, "ngIf"], [1, "mat-form-field-required-marker"], [1, "mat-form-field", "mb-1"], [3, "value", "formControlName"], [3, "innerHTML"]],
        template: function FormCheckboxListComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementContainerStart(0, 0);
            i0.ɵɵtemplate(1, FormCheckboxListComponent_div_1_Template, 9, 14, "div", 1);
            i0.ɵɵelementContainerEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.group);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.group.get(ctx.config.name));
          }
        },
        dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, i2.FormGroupDirective, i2.FormControlName, i3.MatInput, i4.MatError, i5$1.MatCheckbox, FormErrorPipe],
        encapsulation: 2
      });
    }
  }
  return FormCheckboxListComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormCheckboxComponent = /*#__PURE__*/(() => {
  class FormCheckboxComponent {
    constructor() {}
    ngOnInit() {}
    isRequired(ctrl) {
      if (!ctrl.validator) {
        return false;
      }
      const validator = ctrl?.validator({});
      return validator && validator['required'];
    }
    static {
      this.ɵfac = function FormCheckboxComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormCheckboxComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FormCheckboxComponent,
        selectors: [["app-form-checkbox"]],
        decls: 2,
        vars: 2,
        consts: [[3, "formGroup"], ["class", "mat-form-field--checkbox", 3, "has--label", "has--sub-label", "subscriptSizing", 4, "ngIf"], [1, "mat-form-field--checkbox", 3, "subscriptSizing"], ["matInput", "", 3, "formControlName", "hidden"], [3, "formControlName"], [3, "innerHTML"], ["class", "mat-form-field-required-marker", 4, "ngIf"], [3, "innerHTML", 4, "ngIf"], [1, "mat-form-field-required-marker"]],
        template: function FormCheckboxComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementContainerStart(0, 0);
            i0.ɵɵtemplate(1, FormCheckboxComponent_mat_form_field_1_Template, 8, 12, "mat-form-field", 1);
            i0.ɵɵelementContainerEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.group);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.group.get(ctx.config.name));
          }
        },
        dependencies: [i1.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, i2.FormGroupDirective, i2.FormControlName, i3.MatInput, i4.MatFormField, i4.MatLabel, i4.MatError, i5$1.MatCheckbox, FormErrorPipe],
        encapsulation: 2
      });
    }
  }
  return FormCheckboxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormDividerComponent = /*#__PURE__*/(() => {
  class FormDividerComponent {
    constructor() {}
    ngOnInit() {}
    static {
      this.ɵfac = function FormDividerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormDividerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FormDividerComponent,
        selectors: [["app-form-divider"]],
        decls: 4,
        vars: 3,
        consts: [[1, "form-divider", "mt-2", 3, "ngClass"], [1, "form-divider__title", "h4", "mb-0"], [1, "form-divider__intro", "mb-0", 3, "innerHTML"]],
        template: function FormDividerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "section", 0)(1, "h1", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(3, "p", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.config.cssClass);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.config.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("innerHTML", ctx.config["intro"], i0.ɵɵsanitizeHtml);
          }
        },
        dependencies: [i1.NgClass]
      });
    }
  }
  return FormDividerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormHiddenComponent = /*#__PURE__*/(() => {
  class FormHiddenComponent {
    constructor() {}
    ngOnInit() {}
    static {
      this.ɵfac = function FormHiddenComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormHiddenComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FormHiddenComponent,
        selectors: [["app-form-hidden"]],
        decls: 2,
        vars: 2,
        consts: [[3, "formGroup"], ["type", "hidden", 3, "formControlName", 4, "ngIf"], ["type", "hidden", 3, "formControlName"]],
        template: function FormHiddenComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementContainerStart(0, 0);
            i0.ɵɵtemplate(1, FormHiddenComponent_input_1_Template, 1, 1, "input", 1);
            i0.ɵɵelementContainerEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.group);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.group.get(ctx.config.name));
          }
        },
        dependencies: [i1.NgIf, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, i2.FormGroupDirective, i2.FormControlName],
        encapsulation: 2
      });
    }
  }
  return FormHiddenComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormRadioComponent = /*#__PURE__*/(() => {
  class FormRadioComponent {
    constructor() {}
    ngOnInit() {}
    isRequired(ctrl) {
      if (!ctrl.validator) {
        return false;
      }
      const validator = ctrl?.validator({});
      return validator && validator['required'];
    }
    showError(field) {
      return field.invalid && (field.touched || field.dirty);
    }
    static {
      this.ɵfac = function FormRadioComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormRadioComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FormRadioComponent,
        selectors: [["app-form-radio"]],
        decls: 2,
        vars: 2,
        consts: [[3, "formGroup"], ["class", "custom-field", 3, "ngClass", "has--label", "has--sub-label", 4, "ngIf"], [1, "custom-field", 3, "ngClass"], [1, "label"], ["class", "mat-form-field-required-marker", 4, "ngIf"], [1, "custom-field__field", 3, "formControlName"], ["class", "mat-form-field mb-1", 4, "ngFor", "ngForOf"], [1, "custom-field__error-wrapper"], [3, "innerHTML", 4, "ngIf"], [1, "mat-form-field-required-marker"], [1, "mat-form-field", "mb-1"], [3, "value"], [3, "innerHTML"]],
        template: function FormRadioComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementContainerStart(0, 0);
            i0.ɵɵtemplate(1, FormRadioComponent_div_1_Template, 8, 12, "div", 1);
            i0.ɵɵelementContainerEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.group);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.group.get(ctx.config.name));
          }
        },
        dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2.NgControlStatus, i2.NgControlStatusGroup, i2.FormGroupDirective, i2.FormControlName, i4.MatError, i4$1.MatRadioGroup, i4$1.MatRadioButton, FormErrorPipe],
        encapsulation: 2
      });
    }
  }
  return FormRadioComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormSelectComponent = /*#__PURE__*/(() => {
  class FormSelectComponent {
    constructor() {}
    ngOnInit() {}
    static {
      this.ɵfac = function FormSelectComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormSelectComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FormSelectComponent,
        selectors: [["app-form-select"]],
        decls: 4,
        vars: 7,
        consts: [[3, "formGroup"], [3, "appearance", "color", "has--label", "has--sub-label", "subscriptSizing", 4, "ngIf"], ["class", "col-md-6 form-field__help-url d-none d-md-flex", 3, "ngClass", 4, "ngIf"], [3, "appearance", "color", "subscriptSizing"], [3, "formControlName", "placeholder"], [3, "value", 4, "ngFor", "ngForOf"], [4, "ngIf"], [3, "value"], [1, "d-md-none", 3, "href"], [1, "col-md-6", "form-field__help-url", "d-none", "d-md-flex", 3, "ngClass"], [1, "form-field__help-url__link", 3, "href"]],
        template: function FormSelectComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div");
            i0.ɵɵtemplate(2, FormSelectComponent_mat_form_field_2_Template, 6, 12, "mat-form-field", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, FormSelectComponent_div_3_Template, 3, 3, "div", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("row", ctx.config.helpLink);
            i0.ɵɵproperty("formGroup", ctx.group);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("col-md-6", ctx.config.helpLink);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.group.get(ctx.config.name));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.config.helpLink);
          }
        },
        dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2.NgControlStatus, i2.NgControlStatusGroup, i2.FormGroupDirective, i2.FormControlName, i4.MatFormField, i4.MatLabel, i4.MatError, i4$2.MatSelect, i5$2.MatOption, FormErrorPipe],
        encapsulation: 2
      });
    }
  }
  return FormSelectComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormSlideToggleComponent = /*#__PURE__*/(() => {
  class FormSlideToggleComponent {
    constructor() {}
    ngOnInit() {}
    isRequired(ctrl) {
      if (!ctrl.validator) {
        return false;
      }
      const validator = ctrl?.validator({});
      return validator && validator['required'];
    }
    static {
      this.ɵfac = function FormSlideToggleComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormSlideToggleComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FormSlideToggleComponent,
        selectors: [["app-form-slide-toggle"]],
        decls: 3,
        vars: 3,
        consts: [[3, "formGroup"], [1, "mat-form-field", "mat-form-field--slide-toggle", 3, "ngClass"], ["class", "mat-form-field__inner", 3, "has--label", "has--sub-label", 4, "ngIf"], [1, "mat-form-field__inner"], ["class", "label", 4, "ngIf"], [4, "ngIf"], [3, "color", "formControlName"], ["class", "mt-2", 3, "innerHTML", 4, "ngIf"], [1, "label"], [1, "mt-2", 3, "innerHTML"]],
        template: function FormSlideToggleComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementContainerStart(0, 0);
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵtemplate(2, FormSlideToggleComponent_div_2_Template, 6, 10, "div", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementContainerEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.group);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.config.cssClass);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.group.get(ctx.config.name));
          }
        },
        dependencies: [i1.NgClass, i1.NgIf, i2.NgControlStatus, i2.NgControlStatusGroup, i2.FormGroupDirective, i2.FormControlName, i4.MatLabel, i4.MatError, i4$3.MatSlideToggle, FormErrorPipe],
        encapsulation: 2
      });
    }
  }
  return FormSlideToggleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WysiwygEditorComponent = /*#__PURE__*/(() => {
  class WysiwygEditorComponent {
    constructor(fb, platformId) {
      this.fb = fb;
      this.platformId = platformId;
      this.modules = {
        toolbar: [['bold', 'italic', 'underline', 'strike']],
        clipboard: {
          matchVisual: false
        }
      };
      this.fieldFocused = false;
    }
    async ngOnInit() {
      // set toolbar options
      if (this.config['toolbar']) {
        this.modules.toolbar = this.config['toolbar'];
      }
    }
    isRequired(ctrl) {
      if (!ctrl.validator) {
        return false;
      }
      const validator = ctrl?.validator({});
      return validator && validator['required'];
    }
    showError(field) {
      return field.invalid && (field.touched || field.dirty);
    }
    static {
      this.ɵfac = function WysiwygEditorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WysiwygEditorComponent)(i0.ɵɵdirectiveInject(i2.UntypedFormBuilder), i0.ɵɵdirectiveInject(PLATFORM_ID));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WysiwygEditorComponent,
        selectors: [["app-wysiwyg-editor"]],
        viewQuery: function WysiwygEditorComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c1, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.editor = _t.first);
          }
        },
        decls: 1,
        vars: 1,
        consts: [["editor", ""], [4, "ngIf"], [1, "custom-field", "custom-field--has-label", "type--wysiwy", 3, "formGroup", "ngClass"], [1, "label"], [3, "innerHTML"], ["class", "custom-field-subLabel", 3, "innerHTML", 4, "ngIf"], ["class", "custom-field__field", 3, "modules", "placeholder", "formControlName", "minLength", "maxLength", 4, "ngIf"], ["class", "custom-field__field", 3, "modules", "placeholder", "formControlName", "minLength", 4, "ngIf"], [1, "custom-field__error-wrapper"], [3, "innerHTML", 4, "ngIf"], [1, "custom-field-subLabel", 3, "innerHTML"], [1, "custom-field__field", 3, "modules", "placeholder", "formControlName", "minLength", "maxLength"], [1, "custom-field__field", 3, "modules", "placeholder", "formControlName", "minLength"]],
        template: function WysiwygEditorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, WysiwygEditorComponent_ng_container_0_Template, 10, 14, "ng-container", 1);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.group.get(ctx.config.name));
          }
        },
        dependencies: [i1.NgClass, i1.NgIf, i2.NgControlStatus, i2.NgControlStatusGroup, i2.FormGroupDirective, i2.FormControlName, i4.MatError, i4$4.QuillEditorComponent, FormErrorPipe],
        encapsulation: 2
      });
    }
  }
  return WysiwygEditorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const dynamicFormFieldTypes = {
  'input': FormInputComponent,
  'checkbox': FormCheckboxComponent,
  'wysiwyg': WysiwygEditorComponent,
  'select': FormSelectComponent,
  'checkbox-list': FormCheckboxListComponent,
  'radio-list': FormRadioComponent,
  'slidetoggle': FormSlideToggleComponent,
  'divider': FormDividerComponent,
  'hidden': FormHiddenComponent,
  'button-toggle': FormButtonToggleComponent
};
let DynamicFieldDirective = /*#__PURE__*/(() => {
  class DynamicFieldDirective {
    constructor(container, defaultFormConfig) {
      this.container = container;
      this.defaultFormConfig = defaultFormConfig;
    }
    getComponentType(fieldType) {
      if (this.defaultFormConfig.formControls?.hasOwnProperty(fieldType)) {
        return this.defaultFormConfig.formControls[fieldType];
      }
      return dynamicFormFieldTypes[fieldType.toLowerCase()] || FormInputComponent;
    }
    ngOnInit() {
      if (this.hidden) {
        return;
      }
      if (this.config.hasOwnProperty('value')) {
        if (!this.group.value[this.config.name] && this.config.value) {
          this.group.controls[this.config.name].setValue(this.config.value);
        }
      }
      const component = this.getComponentType(this.config.fieldType);
      this.component = this.container.createComponent(component);
      this.component.instance.config = this.config;
      this.component.instance.group = this.group;
    }
    static {
      this.ɵfac = function DynamicFieldDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicFieldDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(DynamicFormConfigService));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: DynamicFieldDirective,
        selectors: [["", "fstrDynamicField", ""]],
        inputs: {
          config: "config",
          group: "group",
          hidden: "hidden"
        }
      });
    }
  }
  return DynamicFieldDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FormComponent = /*#__PURE__*/(() => {
  class FormComponent {
    get value() {
      return this.form?.value;
    }
    constructor(fb, cd, defaultFormConfig) {
      this.fb = fb;
      this.cd = cd;
      this.defaultFormConfig = defaultFormConfig;
      this.formSubmit = new EventEmitter();
      this.formChanges = new EventEmitter();
      this.config = [];
      this.submitButtonLabel = 'submit';
      this.showSubmit = true;
      this.showAlerts = true;
      this.showValidation = true;
      this.debug = false;
      this.fieldsets = [];
      this.form = this.fb.group({});
      this.triedSubmit = false;
      this._unsubscribe = new Subject();
    }
    ngOnInit() {
      this.form = this.createGroup();
      this.form.valueChanges.pipe(debounceTime(100), takeUntil(this._unsubscribe)).subscribe(f => {
        this.formChanges.emit(this.form);
      });
      // Subscribe to status changes on the form
      // and use the statusChange to trigger changeDetection
      this.form.statusChanges.pipe(distinctUntilChanged(), takeUntil(this._unsubscribe)).subscribe(() => this.cd.markForCheck());
    }
    createGroup() {
      const group = this.fb.group({});
      this.config.map(a => a.appearance || this.appearance ? a.appearance = a.appearance || this.appearance : null);
      this.config.forEach(control => {
        if (control.name) {
          const updateOn = control.asyncValidators?.length ? 'change' : 'change';
          const ctrl = this.fb.control(control.value, {
            updateOn
          });
          if (control.disabled) {
            ctrl.disable();
          }
          if (control.validators?.length) {
            ctrl.setValidators(control.validators);
          }
          if (control.asyncValidators?.length) {
            ctrl.setAsyncValidators(control.asyncValidators);
            ctrl.statusChanges.pipe(takeUntil(this._unsubscribe)).subscribe(() => this.cd.markForCheck());
          }
          // Set default value to false to prevent null-value during save
          if (control.fieldType === 'checkbox' && !ctrl.value) {
            ctrl.setValue(false);
          }
          group.addControl(control.name, ctrl);
        }
      });
      return group;
    }
    setValue(object, patch = true) {
      setTimeout(() => {
        if (patch) {
          this.form.patchValue(object);
          return;
        }
        this.form.setValue(object);
      });
    }
    reset() {
      this.form.reset();
      this.triedSubmit = false;
    }
    reload() {
      this.form.reset();
      this.triedSubmit = false;
    }
    shouldBeDisplayed(field) {
      return !field.conditionalDisplay || field.conditionalDisplay.values.includes(this.form.get(field.conditionalDisplay.propertyName)?.value);
    }
    fieldsetShouldBeDisplayed(fields) {
      return fields.some(a => this.shouldBeDisplayed(a));
    }
    onSubmit() {
      this.triedSubmit = true;
      this.form.markAllAsTouched();
      if (this.form.valid) {
        this.formSubmit.emit(this.form.value);
      }
    }
    ngOnDestroy() {
      this._unsubscribe.next();
      this._unsubscribe.complete();
    }
    static {
      this.ɵfac = function FormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FormComponent)(i0.ɵɵdirectiveInject(i2.UntypedFormBuilder), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(DynamicFormConfigService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FormComponent,
        selectors: [["fstr-dynamic-form"]],
        inputs: {
          config: "config",
          submitButtonLabel: "submitButtonLabel",
          showSubmit: "showSubmit",
          showAlerts: "showAlerts",
          initialValue: "initialValue",
          showValidation: "showValidation",
          appearance: "appearance",
          inputErrorMessage: "inputErrorMessage",
          serverErrorMessage: "serverErrorMessage",
          debug: "debug",
          fieldsets: "fieldsets",
          serverError: "serverError"
        },
        outputs: {
          formSubmit: "formSubmit",
          formChanges: "formChanges"
        },
        exportAs: ["DynamicFormComponent"],
        ngContentSelectors: _c3,
        decls: 11,
        vars: 12,
        consts: [["formEl", ""], [1, "form", "row", 3, "ngSubmit", "formGroup", "ngClass"], [4, "ngFor", "ngForOf"], ["class", "form__fieldset col-12", 3, "is--hidden", 4, "ngFor", "ngForOf"], [1, "form__footer", "col-12"], [4, "ngIf"], ["class", "button button--primary", "type", "submit", 4, "ngIf"], ["class", "section-inset-t", 4, "ngIf"], [3, "ngClass", 4, "ngIf"], [3, "ngClass"], ["fstrDynamicField", "", 3, "config", "group"], [1, "form__fieldset", "col-12"], [1, "form__fieldset__header"], [1, "form__fieldset__header__title"], ["type", "button", 1, "form__fieldset__header__toggle", 3, "click"], [1, "row"], ["class", "alert alert--danger", 4, "ngIf"], [1, "alert", "alert--danger"], [3, "innerHTML"], ["type", "submit", 1, "button", "button--primary"], [1, "section-inset-t"]],
        template: function FormComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef(_c2);
            i0.ɵɵelementStart(0, "form", 1, 0);
            i0.ɵɵlistener("ngSubmit", function FormComponent_Template_form_ngSubmit_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onSubmit());
            });
            i0.ɵɵtemplate(2, FormComponent_ng_container_2_Template, 2, 1, "ng-container", 2);
            i0.ɵɵpipe(3, "forFieldset");
            i0.ɵɵtemplate(4, FormComponent_fieldset_4_Template, 11, 13, "fieldset", 3);
            i0.ɵɵelementStart(5, "div", 4);
            i0.ɵɵtemplate(6, FormComponent_ng_container_6_Template, 3, 2, "ng-container", 5);
            i0.ɵɵprojection(7);
            i0.ɵɵtemplate(8, FormComponent_button_8_Template, 3, 1, "button", 6);
            i0.ɵɵprojection(9, 1);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(10, FormComponent_pre_10_Template, 3, 3, "pre", 7);
          }
          if (rf & 2) {
            i0.ɵɵclassProp("hide--validation", !ctx.showValidation);
            i0.ɵɵproperty("formGroup", ctx.form)("ngClass", "form--" + ctx.appearance);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(3, 9, ctx.config, ctx.fieldsets));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngForOf", ctx.fieldsets);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.showAlerts);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.showSubmit);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.debug);
          }
        },
        dependencies: [i1.NgClass, i1.NgForOf, i1.NgIf, i2.ɵNgNoValidate, i2.NgControlStatusGroup, i2.FormGroupDirective, i5.MatIcon, DynamicFieldDirective, i1.JsonPipe, ForFieldsetPipe],
        encapsulation: 2
      });
    }
  }
  return FormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const moduleExports = [FormErrorPipe, FormComponent, ForFieldsetPipe, DynamicFieldDirective];
let DynamicFormModule = /*#__PURE__*/(() => {
  class DynamicFormModule {
    static forRoot(config) {
      // Default config
      config = {
        ...config
      };
      return {
        ngModule: DynamicFormModule,
        providers: [{
          provide: DynamicFormConfigService,
          useValue: config
        }]
      };
    }
    static {
      this.ɵfac = function DynamicFormModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DynamicFormModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: DynamicFormModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, FormsModule, ReactiveFormsModule, MatInputModule, MatFormFieldModule, MatSelectModule, MatCheckboxModule, MatRadioModule, MatSlideToggleModule, MatIconModule, QuillModule.forRoot()]
      });
    }
  }
  return DynamicFormModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DynamicFieldDirective, DynamicFormConfigService, DynamicFormModule, ForFieldsetPipe, FormButtonToggleComponent, FormCheckboxComponent, FormCheckboxListComponent, FormComponent, FormDividerComponent, FormErrorPipe, FormHiddenComponent, FormInputComponent, FormRadioComponent, FormSelectComponent, FormSlideToggleComponent, ValidatorMessagesService, WysiwygEditorComponent, dynamicFormFieldTypes };
